import React, {useState, useEffect} from 'react';
import {theme} from '../../src/themes/default-theme';
import styled from '@emotion/styled';
import {get, orderBy} from 'lodash';
import {gql} from '@apollo/client';

import client from '../../src/graphql/client';
import refactorHb from '../../src/data-restructure/multimedia/hero-banner';
import respImgQuery from '../../src/graphql/queries/resp-img';

import NextLink from '../../src/components/navigation/NextLink';
import Banner from '../../src/components/multimedia/Banner';
import Pagination from '../../src/components/navigation/Pagination';
import Loader from '../../src/components/ui/Loader';
import Text from '../../src/components/typography'

const SearchContainer = styled.div`
  
`

const ResultContainer = styled.div`
  max-width: 780px;
  margin: 0 auto;
  margin-top: 45px;
  margin-bottom: 120px;

  & > div:nth-child(2) {
    border-top: 1px solid ${theme.palette.middleGrey};
  }

  & a {
    text-decoration: none;
  }

  & .MuiPagination-root {
    margin: 0 auto;
    width: max-content;
    margin-top: 20px;

    ${theme.breakpoints.up('md')} {
      margin-top: 26px;
    }
  }

  ${theme.breakpoints.down('sm')} {
    padding-left: 15px;
    padding-right: 15px;
  }
`

const ResultStats = styled.div`
  padding-bottom: 20px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 3px;
  color: ${theme.palette.vividBlue};
  text-transform: uppercase;

  ${theme.breakpoints.up('md')} {
    margin-top: 115px;
  }
`

const SeachResult = styled.div`
  padding-top: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid ${theme.palette.middleGrey};

  ${theme.breakpoints.down('sm')} {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`

const SeachTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: ${theme.palette.charcoal};
  padding-bottom: 16px;

  ${theme.breakpoints.down('sm')} {
    font-size: 15px;
    padding-bottom: 8px;
  }
`

const SeachTeaser = styled.div`
  font-size: 15px;
  color: ${theme.palette.gunmentalGrey};

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

const Search = (props) => {
  const countryCode = props.countryProps.countryCode ? props.countryProps.countryCode : 'AU' ; // process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const region = countryCode.toLowerCase() === 'au' ? 'jayco.com.au' : 'jayco.co.nz';
  // const region = !process.env.DEALER_SITE ? (countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz') : countryCode === 'au' ? 'AU-dealers' : 'NZ-dealers';
  const [loading, setLoading] = useState(false);

  // Elastic Search
  const [searchResults, setSearchResults] = useState();
  let q;
  let searchString;

  if (typeof location !== "undefined" && typeof window !== 'undefined') {
    q = location.search.substring(3);
    searchString = q.split('+').join(' ');
  }

  useEffect(() => {
    async function fetchSearch() {
      setLoading(true);
      // const domain = 'jayconewcastle-com-au-index/';
      const domain = process.env.DEALER_SITE && window.staticly.dealerData.website.indexOf('{{') === -1 ? `${window.staticly.dealerData.website.split('.').join('-')}-index/` : 'jayco-com-au-index/';
      let response = await fetch(`https://search-jayco-com-au-prod2-a6b7vb4pyxngznexxbixw567d4.ap-southeast-2.es.amazonaws.com/${domain}_search?pretty=true&size=100&q=` + q)

      response = await response.json();
      const responseHits = get(response, 'hits.hits', []);

      var responseMainSite = null;
      let responseMainSiteHits = [];

      if (process.env.DEALER_SITE) {
        responseMainSite = await fetch(`https://search-jayco-com-au-prod2-a6b7vb4pyxngznexxbixw567d4.ap-southeast-2.es.amazonaws.com/jayco-com-au-index/_search?pretty=true&size=100&q=` + q)
        responseMainSite = await responseMainSite.json();
        responseMainSiteHits = get(responseMainSite, 'hits.hits', []);
      }

      const orderedResponseHits = orderBy(responseHits, ['score'], ['desc'])
      const orderedMainSiteHits = orderBy(responseMainSiteHits, ['score'], ['desc'])


      const hits = [
        ...orderedResponseHits,
        ...orderedMainSiteHits
      ]


      const filteredHits = hits.filter(item => {

        const permalink = item._source.permalink.split('?domains=')[1];

        if (process.env.DEALER_SITE && item._source.post_type === 'dealer') {
          return false
        }

        if (process.env.DEALER_SITE && item._source.permalink && item._source.permalink.indexOf('/range') !== -1) {
          return true
        }

        if (process.env.DEALER_SITE && item._source.post_meta && item._source.post_meta.assigned_domains && item._source.post_meta.assigned_domains.indexOf(props.countryProps.assignedDomain) === -1){
          return false
        }

        if (process.env.DEALER_SITE && permalink && permalink.indexOf('jayco.com.au') === -1) {
          return false
        }

        return true
      })
      console.log('resultHitsresultHitsresultHits a', filteredHits);

      setSearchResults(filteredHits);
      setLoading(false);
    }
    
    fetchSearch();
  }, []);

  const resultHits = searchResults ? searchResults.map((item, index) => {


    const title = item._source.post_title;
    // const domain = get(item, '_source.meta.assigned_domains[0].value', null);
    const domain = (item._source.permalink && item._source.permalink.indexOf('?domains=') !== -1) ? item._source.permalink.split('?domains=')[1] : ''

    const teaser = item._source._yoast_wpseo_metadesc !== '' ? item._source._yoast_wpseo_metadesc :
      item._source.meta.art_teaser_copy ? item._source.meta.art_teaser_copy[0].value :
      item._source.meta.am_short_description ? item._source.meta.am_short_description[0].value :
      title;
        
    const permalink = item._source.permalink.split('?domains')[0].replace('https://', '');

    
    const link = permalink.replace('preview-master.jayco-com-au.au1.staticlyproject.com','');
    const uri = link.includes('range') ? link :
      link.includes('ambassador') ? '/ambassadors/' + item._source.post_name :
      link.includes('article') ? '/community/article/' + item._source.post_name :
      link.includes('dealer') ? '/dealer/' + item._source.post_name :
      link;

    var dealerLinkArr = permalink.split('/') // replace(/^.*(\\|\/|\:)/, '');
    dealerLinkArr.shift();
    const dealerLink = dealerLinkArr.join('/');

    const dealerSiteUri = dealerLink.includes('range') ? dealerLink :
      dealerLink.includes('ambassador') ? '/ambassadors/' + item._source.post_name :
      dealerLink.includes('article') ? '/community/article/' + item._source.post_name :
      dealerLink;

    const uriLink = process.env.DEALER_SITE ? (dealerSiteUri === permalink ? '/' : dealerSiteUri) : uri
    const uriObj = uriLink.split('staticlyproject.com');
    const url = uriObj.length > 1 ? uriObj[1].replace('-ccnz', '').replace('-ccau', '') : uriObj[0].replace('-ccnz', '').replace('-ccau', '')

    let transformedUrl = url;

    if (process.env.DEALER_SITE && domain) {
      const uriDomain = 'https://www.jayco.com.au'
      if (domain.toLowerCase().indexOf('au-dealers') === -1 || domain.toLowerCase().indexOf('nz-dealers') === -1 ) {
        if (url.indexOf('/') === 0) {
          transformedUrl = uriDomain + url
        } else {
          transformedUrl = `${uriDomain}/${url}`
        }
      } else if (url.indexOf('/') !== 0) {
        transformedUrl = `/${url}`
      }
    } 
    
    return {
      id: item._id ? item._id : index,
      score: item._score || 0,
      title,
      domain,
      domainsPermalink: item._source.permalink,
      teaser,
      url,
      uri: transformedUrl
    }
  }) : null;


  const filteredHits = resultHits && resultHits.filter( (ele, ind) => ind === resultHits.findIndex( elem => elem.title === ele.title && elem.teaser === ele.teaser));

  const indexedHits = process.env.DEALER_SITE ? resultHits : (filteredHits && filteredHits.filter(search => {
    if (search.domainsPermalink.indexOf('?domains') === -1) {
      return true
    } else {
      return search.domainsPermalink && search.domainsPermalink.indexOf(region) !== -1
    }
  }));
  
  console.log('resultHitsresultHitsresultHits', {resultHits, searchResults, filteredHits, indexedHits, region});

  // Pagination
  const paginationLength = indexedHits && Math.ceil(indexedHits.length / 10);

  const [page, setPage] = React.useState(1);
  const [start, setStart] = React.useState(0);
  const [end, setEnd] = React.useState(10);

  const handleChange = (event, value) => {
    setPage(value);
    setStart(value === 1 ? 0 : (value - 1) * 10);
    setEnd(paginationLength === value ? indexedHits.length : value * 10);
  }

  const orderedHits = indexedHits //orderBy(indexedHits, ['score'], ['desc'])

  return (
  	<SearchContainer>
      {props.heroBanner &&
        <Banner
          mainHeading="Search Results"
          bgImage={props.heroBanner.bgImage}
          type="mediumBanner"
        />
      }
      {loading &&
        <Loader />
      }
      {indexedHits &&
        <ResultContainer>

          {indexedHits.length === 0 ? 
            <ResultStats>
              <Text variant="body1" align="center" colour="charcoal">0 results for {searchString}.</Text>
            </ResultStats>
          :
          <>
            <ResultStats>Showing {start + 1} - {orderedHits.length < 10 ? orderedHits.length : end} of {orderedHits.length} for {searchString}</ResultStats>
            {orderedHits.slice(start,end).map((item, index) => {
              return (
                <SeachResult key={item.id || index}>
                  <NextLink href={item.uri}>
                 
                      <SeachTitle dangerouslySetInnerHTML={{__html: item.title}} />
                      <SeachTeaser dangerouslySetInnerHTML={{__html: item.teaser}} />
                   
                  </NextLink>
                </SeachResult>
              )
            })}
            {paginationLength > 1 &&
              <Pagination
                page={page}
                onChange={handleChange}
                count={paginationLength}
              />
            }
          </>}
        </ResultContainer>
      }
    </SearchContainer>
  )
}
  
export async function getStaticProps() {
  const GET_PAGE_CONTEXT = gql`
    query GET_FAQ_PAGE {
      pageBy(uri: "faqs") {
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner {
              fieldGroupName
              shbHeadingText
              shbBannerImage {
                ${respImgQuery}
              }
            }
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  if (contextProps) {
    const context = get(contextProps, 'data.pageBy', null);

    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = refactorHb(hbData[0], 'shb');

    const data = {
      heroBanner
    }

    return {
      revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
      props: {
        ...data,
      }
    }
  } else { 
    return { 
      revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
      props: {} 
    }
  }
}

export default Search
